import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useRiskTheme } from "../api/hooks/useRiskThemes";
import Insights from "../components/Insights";
import { RiskControls } from "../components/riskControls";
import { RiskThemeInformation } from "../components/riskThemeInformation";
import { useDesignSystem } from "../context/designSystemContext";

export const RiskThemePage = () => {
  const { id } = useParams();

  const { designSystem } = useDesignSystem();

  // pega o tema do risco pelo id
  const {
    isLoading,
    error,
    data: dataRisk,
    refetch: refetchRiskTheme,
  } = useRiskTheme(id);

  if (error) return <p>{i18next.t("error_loading_risk")}</p>;

  useTranslation();
  return (
    <div className="max-h-screen overflow-auto">
      <h1 className="font-openSans text-xl font-bold ml-3 mt-3" style={{ color: designSystem?.cssBasics.primaryColor }}>
        {dataRisk ? dataRisk["name"] : null}
      </h1>

      {dataRisk && (
        <>
          <Insights riskId={Number(id)} />
          <RiskThemeInformation
            riskTheme={dataRisk}
            controls={dataRisk.items ?? []}
            refetchRiskTheme={refetchRiskTheme}
          />

          <RiskControls
            riskTheme={dataRisk}
            controls={dataRisk.items ?? []}
            refetchRiskTheme={refetchRiskTheme}
          />
        </>
      )}
    </div>
  );
};
